import styled, { createGlobalStyle } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';
import Flex from '@decisiv/ui-components/lib/components/Flex';

const pacificOcean = toColorString(color.interaction.pacificOcean);
const pacificOcean15 = toColorString(color.interaction.pacificOcean15);
const infoLight = toColorString(color.status.information.light);
const infoDark = toColorString(color.status.information.dark);
const successLight = toColorString(color.status.success.light);
const successDark = toColorString(color.status.success.dark);
const snowWhite = toColorString(color.base.snowWhite);
const fullMoon = toColorString(color.base.fullMoon);
const halfMoon = toColorString(color.base.halfMoon);
const alaskanHusky = toColorString(color.base.alaskanHusky);
const charcoal = toColorString(color.base.charcoal);

export const ModalWidthOverride = createGlobalStyle`
  #propagate-settings-modal {
    max-width: ${rem(spacing.base * 90)};
  }
`;

export const ModalSourceBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem(spacing.base * 2)};
  padding-bottom: ${rem(spacing.base)};
  border-bottom: 1px solid ${fullMoon};
`;

export const IntegrationCard = styled(Flex).attrs({
  flexDirection: 'column',
  marginBottom: 2,
})`
  border: 1px solid ${fullMoon};
  border-radius: ${rem(spacing.base * 0.5)};
  overflow: hidden;
  box-shadow: 0 1px 4px color-mix(in srgb, var(--if-shadow) 18%, transparent);
`;

export const IntegrationCardHeader = styled(Flex).attrs({
  alignItems: 'center',
  paddingX: 2,
  paddingY: 1,
})`
  background-color: ${pacificOcean15};
  border-left: 4px solid ${pacificOcean};
  border-bottom: 1px solid ${fullMoon};
  cursor: pointer;
  user-select: none;

  &:hover {
    filter: brightness(0.97);
  }
`;

export const ChevronWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: transform 0.2s ease;
  transform: rotate(${({ expanded }) => (expanded ? '90deg' : '0deg')});
`;

export const CountBadge = styled.span`
  flex-shrink: 0;
  font-size: ${rem(11)};
  font-weight: 600;
  padding: ${rem(spacing.base * 0.25)} ${rem(spacing.base * 0.75)};
  border-radius: ${rem(spacing.base * 2)};
  white-space: nowrap;
  background-color: ${({ allBound }) => (allBound ? successLight : infoLight)};
  color: ${({ allBound }) => (allBound ? successDark : infoDark)};
`;

export const AttributeContent = styled.div`
  display: ${({ expanded }) => (expanded ? 'block' : 'none')};
`;

export const BindAllRow = styled(Flex).attrs({
  alignItems: 'center',
  paddingX: 2,
  paddingY: 1,
})`
  background-color: ${halfMoon};
  border-bottom: 1px solid ${fullMoon};
`;

export const AttributeRow = styled(Flex).attrs({
  alignItems: 'center',
  paddingX: 2,
  paddingY: 1,
})`
  border-bottom: 1px solid ${fullMoon};
  border-left: 4px solid
    ${({ bound }) => (bound ? pacificOcean : 'transparent')};
  background-color: ${snowWhite};
  transition: border-left-color 0.15s ease;

  &:last-child {
    border-bottom: none;
  }
`;

export const ValuePill = styled.span`
  display: inline-block;
  padding: ${rem(spacing.base * 0.2)} ${rem(spacing.base * 0.5)};
  border-radius: ${rem(spacing.base * 0.3)};
  background-color: ${halfMoon};
  border: 1px solid ${alaskanHusky};
  font-family: monospace;
  font-size: ${rem(12)};
  color: ${charcoal};
  max-width: ${rem(180)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
`;

export const NewValuePill = styled(ValuePill)`
  background-color: ${pacificOcean};
  border-color: ${pacificOcean};
  color: ${snowWhite};
  font-weight: 600;
`;

export const InfoLabel = styled.span`
  font-size: ${rem(11)};
  color: ${alaskanHusky};
  font-style: italic;
  margin-left: ${rem(spacing.base * 0.5)};
`;

export const DescriptionText = styled.p`
  font-size: ${rem(13)};
  color: ${charcoal};
  margin: 0 0 ${rem(spacing.base)} 0;
  line-height: 1.4;
  background-color: ${infoLight};
  border-left: 3px solid ${pacificOcean};
  padding: ${rem(spacing.base * 0.5)} ${rem(spacing.base)};
  border-radius: 0 ${rem(spacing.base * 0.3)} ${rem(spacing.base * 0.3)} 0;
`;

export const DisabledAttributeRowWrapper = styled.div`
  opacity: 0.45;
  cursor: not-allowed;
`;
